// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Roboto';
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
  font-family: 'Roboto';
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
  font-family: 'Roboto';
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/tenants/ais/styles/index.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,+DAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,+DAAsD;AACxD;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,+DAAsD;AACxD","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  src: url('./fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 600;\n  src: url('./fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  src: url('./fonts/Roboto-Bold.ttf') format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
